import {
  FaEnvelope,
  FaGlobe,
  FaPager,
  FaPalette,
  FaPencilAlt,
  FaWindowRestore,
} from 'react-icons/fa';

interface StartedCardProps {
  title: string | undefined;
  content: string | undefined;
  idx: number;
}

const StartedCard = ({ title, content, idx }: StartedCardProps) => {
  const renderIcon = () => {
    switch (idx) {
      case 0:
        return (
          <FaWindowRestore color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />
        );
      case 1:
        return <FaPager color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />;
      case 2:
        return <FaEnvelope color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />;
      case 3:
        return <FaPencilAlt color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />;
      case 4:
        return <FaPalette color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />;
      case 5:
        return <FaGlobe color="#FFF" className="h-6 w-6 lg:h-7 lg:w-7" />;
    }
  };

  return (
    <div className="flex items-center lg:max-w-[440px]">
      <div className="flex min-h-[42px] min-w-[42px] items-center justify-center rounded-xl bg-primary-light-blue lg:min-h-[52px] lg:min-w-[52px]">
        {renderIcon()}
      </div>
      <div className="ml-4 lg:ml-5">
        <p className="text-lg font-semibold text-primary-blue">{title}</p>
        <p className="mt-2 pr-6 text-sm text-primary-grey lg:text-base">
          {content}
        </p>
      </div>
    </div>
  );
};

export default StartedCard;
